import React from 'react';
import { useTranslation } from 'react-i18next';
import { MARK_AS_PAID_STYLES } from '../styles';
import { convertValueToUSD } from '../../../../../../../../../helpers/currency.helper';

const MarkBillAsPaidHeader = ({ amount }: { amount: number }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={MARK_AS_PAID_STYLES.TITLE}>{t('COMPONENTS.MARK_AS_PAID.TITLE')}</div>
      <div className={MARK_AS_PAID_STYLES.SUBTITLE}>{t('COMPONENTS.MARK_AS_PAID.SUBTITLE')}</div>
      <div className='flex mt-[20px]'>
        <div className={MARK_AS_PAID_STYLES.AMOUNT_TITLE}>{t('BILL_PAY.MARK_AS_PAID.AMOUNT_PAID')}</div>
        <div className={MARK_AS_PAID_STYLES.AMOUNT_VALUE} data-testid='billsHub-markAsPaid-amount'>{`${convertValueToUSD(amount, 2)}`}</div>
      </div>
    </>
  );
};

export default MarkBillAsPaidHeader;
